import { render, staticRenderFns } from "./AdminAnnouncementPage.vue?vue&type=template&id=326f8e68&scoped=true"
import script from "./AdminAnnouncementPage.vue?vue&type=script&lang=js"
export * from "./AdminAnnouncementPage.vue?vue&type=script&lang=js"
import style0 from "./AdminAnnouncementPage.vue?vue&type=style&index=0&id=326f8e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f8e68",
  null
  
)

export default component.exports